import { render, staticRenderFns } from "./file-template-item.vue?vue&type=template&id=0e63c0ed&scoped=true"
import script from "./file-template-item.vue?vue&type=script&lang=js"
export * from "./file-template-item.vue?vue&type=script&lang=js"
import style0 from "./file-template-item.vue?vue&type=style&index=0&id=0e63c0ed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e63c0ed",
  null
  
)

export default component.exports